import Phaser from 'phaser'
import { GUARDRAIL_DISTANCE } from '../components/road'

export const SPEED = 600
const FASTER = 900
const SLOWER = 300
const ACCEL = 0.05
const SIDE_SPEED = 300
const SIDE_ACCEL = 0.01
const MAX_ROTATION = 25
const SLIP_DURATION = 600

export const CRASH_ROTATION_SPEED = 0.0015
export const WIDTH = 50
export const HEIGHT = 90

const MIN_LOOK_AHEAD_TIME = 1

// TODO: a little less control over plaeyer movesmentn

export default class Player extends Phaser.GameObjects.Container {
  constructor (scene) {
    super(scene)

    this.hasMoved = false
    this.isScanning = false
    this.isGameOver = false
    this.canLookAhead = false

    this.image = this.scene.add.image(0, 0, 'cars', 'police_car')
    this.image.setSize(WIDTH, HEIGHT)
    this.image.setDisplaySize(WIDTH, HEIGHT)
    this.add(this.image)

    this.blue = this.scene.add.image(-8, 0, 'particles', 'star_08').setTint(0x0000ff).setScale(1).setBlendMode('screen')
    this.red = this.scene.add.image(8, 0, 'particles', 'star_08').setTint(0xff0000).setScale(1).setBlendMode('screen')
    this.add(this.blue)
    this.add(this.red)
    this.scene.tweens.add({
      targets: this.blue,
      duration: 400,
      alpha: { from: 0.8, to: 0 },
      yoyo: true,
      repeat: -1
    })
    this.scene.tweens.add({
      targets: this.red,
      duration: 400,
      alpha: { from: 0, to: 0.8 },
      yoyo: true,
      repeat: -1
    })

    this.keyUp = this.scene.input.keyboard.addKey('up')
    this.keyDown = this.scene.input.keyboard.addKey('down')
    this.keyLeft = this.scene.input.keyboard.addKey('left')
    this.keyRight = this.scene.input.keyboard.addKey('right')
    this.keySpace = this.scene.input.keyboard.addKey('space')
    this.keySpaceWasDown = false

    this.xSpeed = 0
    this.ySpeed = SPEED

    this.lookAheadDuration = 0
    this.lane = -1 // current lane the player is on, updated by the Road class. -1 is offroad
    this.score = 0

    this.godMode = false
    if (process.env.NODE_ENV !== 'production') {
      this.scene.input.keyboard.on('keyup-Q', () => {
        this.godMode = !this.godMode
      })
    }

    const skidConfig = {
      frame: ['skidmark_single_1'],

      on: true,
      active: true,
      frequency: 10,
      quantity: 1,
      lifespan: 5000,

      scale: 0.75,

      follow: this,
      followOffset: {
        x: -18, y: 30
      }
    }
    this.skidmarksLeft = this.scene.particles.createEmitter(skidConfig)
    skidConfig.followOffset.x *= -1
    this.skidmarksRight = this.scene.particles.createEmitter(skidConfig)

    const allSmokeFrames = ['smoke_01', 'smoke_02', 'smoke_03', 'smoke_04', 'smoke_05', 'smoke_06', 'smoke_07', 'smoke_08']
    this.exhaust = this.scene.particles.createEmitter({
      frame: allSmokeFrames,

      on: true,
      active: true,
      frequency: 1,
      quantity: 1,
      lifespan: 400,
      speedX: { min: -40, max: 40 },

      scale: 0.2,
      alpha: { start: 0.6, end: 0 },
      blendMode: 'SCREEN',

      follow: this,
      followOffset: {
        x: 8, y: 30
      }
    })

    this.rubberBurn = this.scene.particles.createEmitter({
      frame: allSmokeFrames,

      on: false,
      active: true,
      frequency: 10,
      quantity: 1,
      lifespan: 400,
      speedX: { min: -200, max: 200 },

      scale: { start: 0.4, end: 1.6 },
      alpha: { start: 0.6, end: 0 },
      blendMode: 'SCREEN',

      follow: this,
      followOffset: {
        x: 0, y: 40
      }
    })
  }

  initialize () {
    this.body.setOffset(-this.image.width * 0.4, -this.image.height * 0.4)
    this.body.setSize(this.image.width * 0.8, this.image.height * 0.8)
  }

  onPressSpace (delta, justPressed) {
    if (!this.isGameOver && this.hasMoved) {
      if (this.lookAheadDuration <= 0) {
        this.lookAheadDuration = MIN_LOOK_AHEAD_TIME
      } else {
        this.lookAheadDuration = Math.max(this.lookAheadDuration - delta / 1000, 0.01)
      }
      this.scene.cameraController.lookAhead()
      if (justPressed && this.score < 50) {
        var isOneEvil = false
        var visibleCars = []
        var cars = this.scene.cars.children
        cars.entries.forEach(car => {
          if (car.id) {
            if (car.y > this.y - 1400 && car.y < this.y - 400) {
              visibleCars.push(car)
              isOneEvil = isOneEvil || car.evil
            }
          }
        })

        if (!isOneEvil && visibleCars.length > 0) {
          this.scene.rnd.pick(visibleCars).setEvil()
        }
      }
    }
  }

  preUpdate (time, delta) {
    if (!this.hasMoved) {
      if (this.keyUp.isDown || this.keyDown.isDown || this.keyLeft.isDown || this.keyRight.isDown || this.keySpace.isDown) {
        this.hasMoved = true
        this.emit('has-moved')
      }
    }
    var targetAngle = 0
    var targetXSpeed = 0
    var bodyScale = 1
    var targetYSpeed = SPEED

    if (this.keyUp.isDown) {
      targetYSpeed = FASTER
    } else if (this.keyDown.isDown) {
      targetYSpeed = SLOWER
    }

    if (this.isGameOver) {
      targetXSpeed = this.body.velocity.x
      targetYSpeed = 0
    } else if (this.keyLeft.isDown) {
      targetXSpeed = -SIDE_SPEED
      targetAngle = -MAX_ROTATION
    } else if (this.keyRight.isDown) {
      targetXSpeed = SIDE_SPEED
      targetAngle = MAX_ROTATION
    }

    this.rubberBurn.followOffset = Phaser.Math.Rotate({ x: 0, y: 40 }, this.rotation)
    this.exhaust.followOffset = Phaser.Math.Rotate({ x: 8, y: 30 }, this.rotation)
    this.skidmarksLeft.followOffset = Phaser.Math.Rotate({ x: -18, y: 30 }, this.rotation)
    this.skidmarksRight.followOffset = Phaser.Math.Rotate({ x: 18, y: 30 }, this.rotation)
    const skidding = this.keyLeft.isDown || this.keyRight.isDown || this.slipping > 1 || this.isGameOver
    this.skidmarksLeft.active = skidding
    this.skidmarksRight.active = skidding
    this.rubberBurn.on = skidding && !this.keyDown.isDown

    if (this.isGameOver) {
      this.angle += this.body.velocity.x * delta * CRASH_ROTATION_SPEED
    } else if (this.slipping > 0) {
      this.slipping -= delta
      targetXSpeed = SIDE_SPEED * this.slipDirection * 0.75

      if (this.slipping > SLIP_DURATION * 0.25) {
        this.angle += this.slipDirection * delta * SIDE_ACCEL * 20
      } else {
        this.angle += this.slipDirection * delta * SIDE_ACCEL * -20
        targetYSpeed = SLOWER
      }
    } else {
      this.angle += (targetAngle - this.angle) * (delta * SIDE_ACCEL)
    }

    bodyScale = 1 - (Math.abs(Phaser.Math.Clamp(this.angle, -30, 30)) / MAX_ROTATION) * 0.25 // make the collision up to 25% smaller when turning

    this.body.setOffset(-this.image.width * 0.5 * bodyScale, -this.image.height * 0.5 * bodyScale)
    this.body.setSize(this.image.width * bodyScale, this.image.height * bodyScale)

    this.xSpeed = this.xSpeed + (targetXSpeed - this.xSpeed) * (delta * SIDE_ACCEL)
    this.ySpeed = this.ySpeed + (targetYSpeed - this.ySpeed) * (delta * this.isGameOver ? ACCEL / 4 : ACCEL)
    this.body.velocity.x = this.xSpeed
    this.body.velocity.y = -this.ySpeed

    if (this.keySpace.isUp && this.hasMoved) {
      this.canLookAhead = true
    }
    if (this.keySpace.isDown && this.hasMoved && this.canLookAhead) {
      this.onPressSpace(delta, !this.keySpaceWasDown)
      if (!this.isScanning) {
        this.isScanning = true
        this.emit('scanning')
      }
    } else {
      if (this.isScanning) {
        this.isScanning = false
        this.emit('backing')
      }
      this.lookAheadDuration = Math.max(this.lookAheadDuration - delta / 1000, 0)
      if (this.lookAheadDuration <= 0) {
        this.scene.cameraController.lookAtPlayer()
      }
    }
    this.keySpaceWasDown = this.keySpace.isDown

    // hit the guardrail?
    if (this.lane < 0) {
      var section = this.scene.road.getLanesAt(this.y)
      if (section.length > 0) {
        if (this.x < section[0] - GUARDRAIL_DISTANCE || this.x > section[section.length - 1] + GUARDRAIL_DISTANCE) {
          var dir = -1
          if (this.x < section[0] - GUARDRAIL_DISTANCE) {
            dir = 1
          }
          this.xSpeed = dir * 200
          this.body.velocity.x = this.xSpeed
          if (!this.isGameOver) {
            this.scene.gameover()
          }
        }
      }
    }
  }

  slip () {
    this.slipping = SLIP_DURATION
    this.slipDirection = this.scene.rnd.frac() < 0.5 ? -1 : 1
  }

  collidedWith (other) {
    this.body.velocity.x = other.x < this.x ? 150 : -150
  }
}
